module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('SystemPanel', [_c('div', {
    staticClass: "confirm-form confirm-form-with-syspanel"
  }, [_vm._t("default", [_c('h5', [_vm._v("此藥盒數量")])]), _vm._v(" "), (_vm.onlyPc) ? _c('div', {
    staticClass: "interactive-input--wrap"
  }, [_c('div', {
    staticClass: "interactive-input"
  }, [(_vm.inputReadOnly === false) ? _c('div', {
    staticClass: "calculate-button add-button",
    on: {
      "click": function($event) {
        return _vm.addNum('pieces')
      }
    }
  }, [_vm._v("+")]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pieces),
      expression: "pieces"
    }],
    ref: "input",
    class: {
      'form-control': true, 'long-input': _vm.inputReadOnly, 'width-input': true
    },
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "type": "number",
      "readonly": _vm.inputReadOnly,
      "min": "0"
    },
    domProps: {
      "value": (_vm.pieces)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pieces = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.inputReadOnly === false) ? _c('div', {
    staticClass: "calculate-button miuns-button",
    on: {
      "click": function($event) {
        return _vm.minusNum('pieces')
      }
    }
  }, [_vm._v("−")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.hasSlot === false && _vm.onlyPc === false) ? _c('div', {
    staticClass: "interactive-input--wrap row"
  }, [_c('div', {
    staticClass: "col-10"
  }, [_c('div', {
    staticClass: "interactive-input"
  }, [_c('div', {
    staticClass: "input-unit"
  }, [_vm._v("盒/瓶")]), _vm._v(" "), (_vm.inputReadOnly === false) ? _c('div', {
    staticClass: "calculate-button add-button",
    on: {
      "click": function($event) {
        return _vm.addNum('packCount')
      }
    }
  }, [_vm._v("+")]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.packCount),
      expression: "packCount"
    }],
    ref: "input",
    class: {
      'form-control': true, 'long-input': _vm.inputReadOnly
    },
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "type": "number",
      "readonly": _vm.inputReadOnly,
      "min": "0"
    },
    domProps: {
      "value": (_vm.packCount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.packCount = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.inputReadOnly === false) ? _c('div', {
    staticClass: "calculate-button miuns-button",
    on: {
      "click": function($event) {
        return _vm.minusNum('packCount')
      }
    }
  }, [_vm._v("−")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "input-multiply"
  }, [_vm._v("X " + _vm._s(_vm.selectedDrug.pack_content))])]), _vm._v(" "), _c('div', {
    staticClass: "interactive-input"
  }, [_c('div', {
    staticClass: "input-unit"
  }, [_vm._v("pc.")]), _vm._v(" "), (_vm.inputReadOnly === false) ? _c('div', {
    staticClass: "calculate-button add-button",
    on: {
      "click": function($event) {
        return _vm.addNum('pieces')
      }
    }
  }, [_vm._v("+")]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pieces),
      expression: "pieces"
    }],
    ref: "input",
    class: {
      'form-control': true, 'long-input': _vm.inputReadOnly
    },
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "type": "number",
      "readonly": _vm.inputReadOnly,
      "min": "0"
    },
    domProps: {
      "value": (_vm.pieces)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pieces = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.inputReadOnly === false) ? _c('div', {
    staticClass: "calculate-button miuns-button",
    on: {
      "click": function($event) {
        return _vm.minusNum('pieces')
      }
    }
  }, [_vm._v("−")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "input-multiply"
  }, [_vm._v("X 1")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-2 amount-sum"
  }, [_c('p', [_vm._v("總數量")]), _vm._v(" "), _c('div', {
    staticClass: "total-num"
  }, [_vm._v("\n          " + _vm._s(_vm.totalSum) + "\n        ")])])]) : _vm._e(), _vm._v(" "), (_vm.hasSlot) ? _vm._t("interactive") : _vm._e(), _vm._v(" "), (_vm.compType === 'Action') ? _c('div', [(_vm.showRemainInfo) ? _c('p', {
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_vm._v("預計剩餘藥物數量 / 藥盒內數量: " + _vm._s(_vm.remainTotalAmount) + " / " + _vm._s(_vm.remainAmountInDrugInDevice))]) : _vm._e(), _vm._v(" "), (_vm.canDirectlyToNext) ? _c('button', {
    staticClass: "btn btn-lg confirm-button",
    on: {
      "click": _vm.emitData
    }
  }, [_vm._v("關閉抽屜或點選以完成動作")]) : _c('p', {
    staticClass: "hint-text"
  }, [_c('strong', [_vm._v(_vm._s(_vm.constructionContext))]), _vm._v(" "), (_vm.goToNext === false) ? _c('span', [_vm._v("完成動作")]) : _c('span', [_vm._v("進入下一動作")])])]) : _vm._e(), _vm._v(" "), (_vm.compType === 'Confirm') ? _c('div', {
    staticClass: "fake-button-wrap"
  }, [_c('button', {
    staticClass: "btn control-button control-button-red confirm-amount-button",
    attrs: {
      "disabled": !_vm.confirmAvaliable
    },
    on: {
      "click": _vm.confirmAmountAction
    }
  }, [_vm._v("確認數量")])]) : _vm._e()], 2), _vm._v(" "), (_vm.modalStatus.lockDevice) ? _c('lock-device', {
    on: {
      "errorReturned": _vm.errorReturned
    }
  }) : _vm._e(), _vm._v(" "), (_vm.modalStatus.lockDrawer) ? _c('lock-drawer', {
    on: {
      "errorReturned": _vm.errorReturned
    }
  }) : _vm._e(), _vm._v(" "), _c('scan-barcode', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    on: {
      "setBarcode": _vm.confirmReturnEmptyBottle
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0909fe5a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/flowComp/Action.vue
// module id = 1374
// module chunks = 1